module.exports = (__webpack_require__(11))(94);


//////////////////
// WEBPACK FOOTER
// delegated ../../node_modules/react-redux/es/index.js from dll-reference vendor_lib
// module id = 17
// module chunks = 0